var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOjedaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105.83,
    height: 52.917,
    viewBox: "8.085 10.142 105.833 52.917",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.001 -260.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m26.458 323.46-26.458-13.229 26.458-13.229 26.458 13.229z",
    fill: "#005dab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.458 323.46-26.458-13.229 26.458-13.229 26.458 13.229z",
    fill: "#005dab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-26.458 323.46-26.458-13.229 26.458-13.229 26.458 13.229z",
    fill: "#005dab",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-26.458 270.54v26.458l-26.458 13.229v-26.458z",
    fill: "#8ac4f9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.458 270.54v26.458l26.458 13.229v-26.458z",
    fill: "#8ac4f9",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-52.917 283.77v26.458l26.458 13.229v-26.458z",
    fill: "#005dab",
    opacity: 0.95,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 283.77v26.458l-26.458 13.229v-26.458z",
    fill: "#0092c1",
    opacity: 0.9,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.0276e-7 283.77v26.458l26.458 13.229v-26.458z",
    fill: "#17a0c3",
    opacity: 0.9,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.917 283.77v26.458l-26.458 13.229v-26.458z",
    fill: "#005dab",
    opacity: 0.95,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.2917 306.26v-13.229l15.875 7.9375v13.229z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3.4396
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(.26458)",
    d: "m-12.82 1096.9-73.182 36.859-0.17774 64.635 13.172-6.5859v-24.396l47.008-23.504-0.12305 24.459 12.947-6.4746zm-13.305 19.561-0.06445 15.02-46.963 23.545 0.01953-15.06z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOjedaLogo);
export default __webpack_public_path__ + "static/media/ojeda_logo.f9250b59883bf3615dab07222eca26d3.svg";
export { ForwardRef as ReactComponent };